<div class="code-container">
    <div>
        <div style="float:left;">{{ code.value }}</div>
        <div *ngIf="mode == 'delete'" (click)="callAction()" class="code-action-button" matTooltip="Supprimer ce code">
            <fa-icon [icon]="['far', 'trash-alt']" size="lg"></fa-icon>
        </div>
        <div *ngIf="mode == 'add'" (click)="callAction()" class="code-action-button" matTooltip="Ajouter ce code">
            <fa-icon [icon]="['far', 'plus-circle']" size="lg"></fa-icon>
        </div>
    </div>
    <div class="code-label" matTooltip="{{code.properties.label}}">{{ code.properties.label | substring: 50}}</div>
    <div *ngIf="hasExtras && mode == 'delete'">
        <div *ngFor="let extra of extras">
            <mat-form-field class="field-small" appearance="legacy">
                <mat-label>{{extra.name}}</mat-label>
                <input matInput placeholder="{{extra.name}}" [value]="getField(extra.name)" (change)="setField(extra.name,$event.target.value)">
            </mat-form-field>        
        </div>
    </div>
</div>